import { useSessionValue } from '@portal/appLayer/auth';
import { useStoreValue } from './useStore';
import { useEffect, useState } from 'react';
import { scrollDepthEvent } from '@portal/analytics/events';
import { useRouter } from 'next/router';

export const useScrollDepthEvent = () => {
  const session = useSessionValue()
  const store = useStoreValue();
  const router = useRouter();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleRouteChange = () => {
      setScrolled(false);
    }
    const handleScroll = () => {
      const total = document.body.scrollHeight - window.innerHeight;
      const current = window.scrollY;

      const percentage = (current / total) * 100;
      if (percentage >= 50 && !scrolled) {
        scrollDepthEvent({
          eventId: Date.now().toString(),
          page: window.location.pathname,
          user: {
            email: session?.customer.email || ''
          },
          store
        })
        setScrolled(true);
      }
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [scrolled, router, session?.customer.email, store]);

  return { scrolled };
};
